import React from 'react';
import Barcode from 'react-barcode';
import { Card, CardTitle, CardText, CardMedia } from 'material-ui/Card';
import { Row, Col, Panel, PanelGroup, Button, FlexboxGrid, Tree, Container, Sidebar, Header, Footer, Content } from 'rsuite';

const parentStyles = {
    position: 'relative',
    width: '3.8in',
    height: '5.8in',
};


const barcodeStyles = {
    transform: 'translate(-50%, -50%) rotate(270deg)',
    top: '50%',
    left: '50%',
    position: 'absolute',
    textAlign: 'center',
};



const pageStyles = {
    width: '4in',
    height: '6in',
    position: 'relative',
    pageBreakAfter: 'always'
};

export default class BarcodeMultipleCard extends React.Component {
    render() {
        const { barcode } = this.props;

        return (

            <div style={pageStyles}>
                <div style={parentStyles}>
                    <div style={barcodeStyles}>
                        <Barcode value={barcode} format="CODE128" />
                        {this.props.barcodeContent ?
                            this.props.barcodeContent :
                            null
                        }
                    </div>
                </div>
            </div>



        );
    }
}


